import { render, staticRenderFns } from "./DesiredAssetPicker.vue?vue&type=template&id=377697d0&scoped=true"
import script from "./DesiredAssetPicker.vue?vue&type=script&lang=js"
export * from "./DesiredAssetPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377697d0",
  null
  
)

export default component.exports